import { FC } from 'react';
import { SearchSugItem } from 'shared/models';
import Magnifyingglass from '@lemon8/design/lib/icons/icon_assets/magnifyingglass.svg';
import ArrowUpLeftFill from '@lemon8/design/lib/icons/icon_assets/arrow_up_left_fill.svg';

import './style.scss';

const HighlightTxt: FC<{ item: SearchSugItem }> = ({ item }) => {
  const { highlightPos, text } = item;
  const [start, end] = highlightPos;

  return (
    <>
      {text.substring(0, start)}
      {Boolean(text.substring(start, end + 1)) && <span className="highlight">{text.substring(start, end + 1)}</span>}
      {text.substring(end + 1)}
    </>
  );
};

export const SearchItem: FC<{ item: SearchSugItem; onClick: (item: SearchSugItem) => void }> = ({ item, onClick }) => {
  if (!item?.text) {
    return null;
  }

  return (
    <div className="sug-item normal" key={item.id} onClick={() => onClick(item)}>
      <Magnifyingglass className="sug-item-icon" />
      <div className="sug-item-container">
        <span className="sug-item-text">
          <HighlightTxt item={item} />
        </span>
        {item.isUserVerify && <div className="user-auth-icon" />}
      </div>
      {item.avatar && <img className="sug-item-avatar" src={item.avatar} />}
      <ArrowUpLeftFill className="sug-item-operate" />
    </div>
  );
};
